/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: d70118fc6fbc1ac5744ce80ec717c8ecc18bd5db6eb037d2cf569a68f431aead
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Checkbox.style'

export type CheckboxProps = {
  className?: string
  checked?: boolean
  disabled?: boolean
  error?: boolean
  indeterminate?: boolean
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  'aria-checked'?: never
  'aria-invalid'?: never
  children?: never
  type?: never
} & Omit<
  ComponentProps<'input'>,
  | 'aria-checked'
  | 'aria-invalid'
  | 'checked'
  | 'children'
  | 'className'
  | 'disabled'
  | 'onChange'
  | 'type'
>

function Checkbox(props: CheckboxProps): ReactElement {
  const {
    checked,
    className = '',
    defaultChecked = false,
    disabled = false,
    error = false,
    indeterminate = false,
    onChange,
    readOnly,
    ...rest
  } = props
  const inputRef = React.useRef<HTMLInputElement>(null)
  const [localChecked, setLocalChecked] = React.useState(defaultChecked)
  const resolvedChecked = checked ?? localChecked

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  React.useEffect(() => {
    inputRef.current?.setCustomValidity(
      error ? 'Your input is invalid.' : '',
    )
  }, [error])

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (checked === undefined) {
      setLocalChecked(event.currentTarget.checked)
    }

    onChange?.(event)
  }

  return (
    <span
      className={cn('Checkbox', className, { checked: resolvedChecked, 'not-checked': !resolvedChecked, disabled, error, indeterminate })}
      css={style}
    >
      <input
        {...rest}
        aria-checked={indeterminate ? 'mixed' : resolvedChecked}
        aria-invalid={error ? true : undefined}
        checked={resolvedChecked}
        className='input'
        disabled={disabled}
        onChange={handleChange}
        readOnly={readOnly ?? (checked !== undefined && !onChange)}
        ref={inputRef}
        type='checkbox'
      />
      <span aria-hidden={true} className='indicator' />
    </span>
  )
}

export default Checkbox
